import { Link } from "react-router-dom";
import { featuredCollections } from "@/mocks/home";
import SectionHeading from "@/components/base/SectionHeading";

export default function Collections() {
  return (
    <div>
      <SectionHeading eyebrow="编辑精选" title="推荐专题合集" />
      <div className="grid grid-cols-1 gap-4">
        {featuredCollections.map((collection) => (
          <Link
            key={collection.id}
            to={collection.link}
            className="group flex items-center justify-between gap-4 rounded-lg border border-background-200 bg-background-50 p-4 transition-colors hover:border-primary-300 md:p-5"
          >
            <div className="min-w-0">
              <h3 className="text-sm font-semibold text-foreground-950 transition-colors group-hover:text-primary-700 md:text-base">
                {collection.title}
              </h3>
              <p className="mt-1 line-clamp-1 text-xs text-foreground-600">{collection.desc}</p>
            </div>
            <span className="flex shrink-0 items-center gap-1 rounded-full bg-primary-100 px-3 py-1 text-xs font-medium text-primary-700">
              {collection.count} 篇
              <i className="ri-arrow-right-line"></i>
            </span>
          </Link>
        ))}
      </div>
    </div>
  );
}